import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1647.6075,931.312961 L1644.94274,1638.92722 L1408.38494,1875.60614 L1408.26382,1875.60614 L1055.78906,1523.13139 L1647.6075,931.312961 Z M792.789603,1438.70703 L878.425222,1524.46377 L614.129721,1788.63815 L528.494102,1703.00253 L792.789603,1438.70703 Z M616.624903,1262.66345 L702.260521,1348.29907 L349.906895,1700.53157 L264.271276,1614.89595 L616.624903,1262.66345 Z M440.532877,1086.41396 L526.04737,1172.17071 L85.6356184,1612.46133 L0,1526.94684 L440.532877,1086.41396 Z M1033.44144,317.280141 L441.744131,908.977447 L89.2693787,556.744946 L325.948301,320.066024 L1033.44144,317.280141 Z M1630.9891,276.109636 L1686.94901,278.168767 L1689.25039,334.249801 C1691.55177,389.240708 1675.9266,473.180571 1588.35298,560.63307 L1545.59573,603.511442 L1361.48521,419.279793 L1404.24245,376.401421 C1490.84707,289.917925 1576.48269,274.292756 1630.9891,276.109636 Z M1890.43959,74.0725619 C1817.15875,46.4559834 1549.22949,-27.3093513 1274.88059,247.039554 L570.173333,951.746806 L791.590462,1173.28506 L1013.00759,1394.70219 L1717.71484,689.873812 C1990.73137,416.857286 1917.57166,146.868894 1890.43959,74.0725619",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconQuizSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconQuizSolid, _Component);

  var _super = _createSuper(IconQuizSolid);

  function IconQuizSolid() {
    _classCallCheck(this, IconQuizSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconQuizSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconQuiz",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconQuizSolid.displayName = "IconQuizSolid";
  return IconQuizSolid;
}(Component);

IconQuizSolid.glyphName = 'quiz';
IconQuizSolid.variant = 'Solid';
IconQuizSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconQuizSolid;
export { IconQuizSolid };